var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.2979C0 11.774 11.774 0 26.2979 0C40.8218 0 52.5957 11.774 52.5957 26.2979C52.5957 40.8218 40.8218 52.5957 26.2979 52.5957C11.774 52.5957 0 40.8218 0 26.2979Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2552 20.8191L27.9414 30.1329L22.4627 24.6542L15.3403 31.7765",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6812 20.8191H37.2556V27.3936",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowContainer);
export default __webpack_public_path__ + "static/media/ArrowContainer.e1e7e3933c0402f0051a55723993ab61.svg";
export { ForwardRef as ReactComponent };